// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FobFf","importantInfo":"styles_importantInfo__2DxiS"};